var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookmark = function SvgBookmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgBookmark",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgBookmark{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    className: "svgBookmark svgBase svgHover svgSelect",
    d: "M14.6,0.6H3.4c-1.1,0-2.1,0.9-2.1,2.1v14.1c0,0.3,0.3,0.6,0.6,0.6c0.1,0,0.2,0,0.3-0.1l5.2-3.5 l5.2,3.5c0.3,0.2,0.6,0.1,0.8-0.2c0.1-0.1,0.1-0.2,0.1-0.3V7.7h2.4c0.3,0,0.6-0.3,0.6-0.6V2.7C16.6,1.5,15.7,0.6,14.6,0.6z  M15.5,2.7v3.9h-1.8V2.7c0-0.5,0.4-0.9,0.9-0.9S15.4,2.1,15.5,2.7C15.5,2.7,15.5,2.7,15.5,2.7L15.5,2.7z M12.7,1.8 c-0.1,0.3-0.2,0.6-0.2,0.9v13l-4.6-3.1c-0.2-0.1-0.5-0.1-0.7,0l-4.6,3.1v-13c0-0.5,0.4-0.9,0.9-0.9L12.7,1.8L12.7,1.8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmark.4608b334.svg";
export { ForwardRef as ReactComponent };